import React from "react";
import { useNavigate } from "react-router-dom";
import thumbUpImg from "../images/icons8-thumbs-up-64.png";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-90 relative overflow-hidden pt-8 bg-gray-50">
      <div className="max-w-7xl px-4 w-full flex flex-col items-center justify-center space-y-8 bg-white p-8 text-center">
        <img
          src={thumbUpImg}
          alt="thumbs-up"
          className="w-24 sm:w-32 md:w-48 lg:w-64 hover:scale-105 transition-transform duration-300"
        />
        <h1 className="text-4xl font-bold text-green-600">Thank You !</h1>
        <p className="mt-4 text-gray-600">
          We’ve received your request and we are thrilled you’re taking this
          step to grow your practice.
        </p>
        <p className="mt-4 text-gray-600">
          {" "}
          Our team at{" "}
          <b className="text-base md:text-xl lg:text-2xl text-left text-black font-bold font-impact ">
            DUMOSH
            <span className="text-base md:text-xl lg:text-2xl text-left  text-[#FF3E3E] ">
              .
            </span>
          </b>{" "}
          we’ll be in touch shortly.
        </p>
        <button
          className="w-50 mt-6 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          onClick={() => navigate("/")}
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
